import { render, staticRenderFns } from "./AmeldingFormPaycheckHeader.vue?vue&type=template&id=bea4a91a&scoped=true&functional=true&"
import script from "./AmeldingFormPaycheckHeader.vue?vue&type=script&lang=ts&"
export * from "./AmeldingFormPaycheckHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingFormPaycheckHeader.vue?vue&type=style&index=0&id=bea4a91a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "bea4a91a",
  null
  
)

export default component.exports